import { Component, OnInit } from '@angular/core';
import { FilterComponentBase } from 'src/app/main/filter-component-base';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-filter-text',
  templateUrl: './filter-text.component.html',
  styleUrls: ['./filter-text.component.scss']
})
export class FilterTextComponent extends FilterComponentBase implements OnInit {

  constructor() { 
    super() 
  }

  ngOnInit() {
  }

}
